import { useEffect } from 'react';

const TermsOfService = () => {
  useEffect(() => {
    document.title = 'HexaCRM - Terms & Conditions';
  }, []);

  return (
    <div>
      {/* Page Header */}
      <section className="page-header">
        <div className="container position-relative z-2">
          <div className="row justify-content-center text-center">
            <div className="col-lg-8">
              <h1 className="display-3 text-white fw-bold">Terms & Conditions</h1>
              <p className="lead hero-text">
                Please read these terms carefully
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-lg">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="card shadow">
                <div className="card-body p-5">
                  <p className="text-muted mb-4">Effective Date 03.02.26</p>

                  <p className="text-muted mb-4">
                    By accessing or using Hexa CRM, you agree to the following Terms & Conditions.
                  </p>

                  <h4 className="fw-bold">Use of the Application</h4>
                  <ul className="text-muted mb-4">
                    <li>Hexa CRM is provided for business and commercial use only</li>
                    <li>Users must provide accurate information during registration</li>
                    <li>You are responsible for maintaining the confidentiality of your login credentials</li>
                  </ul>

                  <h4 className="fw-bold">User Responsibilities</h4>
                  <p className="text-muted mb-2">You agree not to:</p>
                  <ul className="text-muted mb-4">
                    <li>Use the platform for illegal or unauthorized purposes</li>
                    <li>Upload malicious content or attempt to breach system security</li>
                    <li>Misuse WhatsApp or call features for spam or unlawful communication</li>
                  </ul>

                  <h4 className="fw-bold">Call & Messaging Features</h4>
                  <ul className="text-muted mb-4">
                    <li>Call logs and WhatsApp messages are recorded only for business process tracking</li>
                    <li>Users are responsible for ensuring compliance with local communication and data protection laws</li>
                    <li>Hexa CRM is not responsible for misuse of communication features by users</li>
                  </ul>

                  <h4 className="fw-bold">Data Ownership</h4>
                  <ul className="text-muted mb-4">
                    <li>All business data entered into Hexa CRM remains the property of the customer</li>
                    <li>Hexa CRM does not claim ownership over customer, lead, or inventory data</li>
                  </ul>

                  <h4 className="fw-bold">Service Availability</h4>
                  <ul className="text-muted mb-4">
                    <li>We strive to maintain high availability but do not guarantee uninterrupted service</li>
                    <li>Maintenance, updates, or technical issues may cause temporary downtime</li>
                  </ul>

                  <h4 className="fw-bold">Limitation of Liability</h4>
                  <p className="text-muted mb-2">Hexa CRM shall not be liable for:</p>
                  <ul className="text-muted mb-4">
                    <li>Data loss due to user error or third-party service failures</li>
                    <li>Business losses arising from system downtime or misuse</li>
                    <li>Indirect or consequential damages</li>
                  </ul>

                  <h4 className="fw-bold">Termination</h4>
                  <p className="text-muted mb-4">
                    We reserve the right to suspend or terminate accounts that violate these terms without prior notice.
                  </p>

                  <h4 className="fw-bold">Changes to Terms</h4>
                  <p className="text-muted mb-4">
                    These Terms may be updated periodically. Continued use of the application indicates acceptance of the updated terms.
                  </p>

                  <h4 className="fw-bold">Governing Law</h4>
                  <p className="text-muted mb-4">
                    These Terms shall be governed by the laws of India
                  </p>

                  <h4 className="fw-bold">Contact Information</h4>
                  <p className="text-muted mb-1">For support or legal inquiries:</p>
                  <p className="text-muted mb-0">Email: <a href="mailto:sales@blazehexa.com" className="text-primary">sales@blazehexa.com</a></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsOfService;
